<template>
  <div class="c-app">
    <Sidebar :fatherpath="fatherpath"/>
    <CWrapper>
      <Header :logOut="logOut">
      </Header>
      <div class="c-body">
        <CAlert
          @update:show="(value)=> alertEvent(value)"
          class="w-50 mx-auto mt-5 fixed-top"
          :color="alert.color" 
          :closeButton="typeof(alert.show)!=='number'"
          :show.sync="alert.show" >
          {{ alert.message }}   
          <CProgress
            v-if="typeof(alert.show)=='number'"
            :max="5"
            :value="alert.show"
            height="3px"
            :color="alert.color"
            animate
            class="my-3" />         
        </CAlert>
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <Footer>
        </Footer>
      </div>
    </CWrapper>
  </div>
</template>

<script>
  import Sidebar from './containers/Sidebar'
  import Header from './containers/Header'
  import Footer from './containers/Footer'
  import { 
    validaSesionUsuario,
    actualizaSesionUsuario
  } from '../api'
  import { errorMessage, user_uid } from '../general'

  export default {
    name: 'Dashboard',
    props:{
      fatherpath: String
    },
    components: {
      Sidebar,
      Header,
      Footer
    },
    data() {
      return {
        showModal: false,
        modalMessage: '',
        interval: {}
      }
    },
    methods:{
      alertEvent(value){
        if (typeof(value) == 'boolean') {
          this.$store.commit('setAlert',{ show: false })
        } else {
          // console.log(value)
          if (!value) {
            this.$store.commit('setAlert',{ show: false })
          }
        }
      },
      async logOut(message = 'Sesión finalizada!') {
        if(this.$store.state.user.type === 'E'){
          // await this.updateSessionStatus();
          await actualizaSesionUsuario(this, user_uid(), 'I');

          this.$store.commit('setMInterval', ['cancel', null])
        }
        
        this.$store.commit('setUserValue', ['token', ''])
        this.$store.commit('setUserValue', ['isLoggedIn', false])
        this.$store.commit('setUserValue', ['logginDate', ''])
        this.$store.commit('setUserValue', ['data', {}])

        this.$store.commit('resetCart')       
        this.$store.commit('resetQuote')
        this.$store.commit('set', ['quoteActiveTab', 0])
        this.$store.commit('setAlert', {
          color: 'info',
          message: message,
          show: 5
        });

        this.$router.push({ path:"/login" });
      },
      async checkSessionStatus() {
        try {
          await validaSesionUsuario(this, user_uid());
        } catch(error) {
          //console.log(error.response.status)

          if (error.response.status != 401) {
            return this.logOut()
          }

          this.logOut(errorMessage(error.response))
        }
      },
      async updateSessionStatus() {
        try{
          await actualizaSesionUsuario(this, user_uid(), 'I');
        } catch(error) {
          console.log(error)
          this.logOut()
        }
      }
    },
    computed:{
      alert(){
        return this.$store.state.alert
      }
    },
    async mounted() {
      if(this.$store.state.user.type === 'E'){
        await this.checkSessionStatus();

        const interval = setInterval(
          () => {
            this.checkSessionStatus()
          },
          30000
        );

        this.$store.commit('setMInterval', ['add', interval])
      }
    }
  }
</script>